// Real Cherry financing widget loader (matches the original site's embed).
const CHERRY_CONFIG = {
  debug: false,
  variables: {
    slug: "elizabeth-taylor-",
    name: "Seraphina Collective",
    images: [26],
    customLogo: "",
    defaultPurchaseAmount: 750,
    customImage: "",
    imageCategory: "medspa",
    language: "en",
  },
  styles: {
    primaryColor: "#dac160",
    secondaryColor: "#dac16010",
    fontFamily: "Montserrat",
    headerFontFamily: "Montserrat",
    floatingEstimator: {
      position: "bottom-right",
      offset: { x: "0px", y: "0px" },
      zIndex: 9999,
      ctaFontFamily: "Montserrat",
      bodyFontFamily: "Montserrat",
      ctaColor: "#dac160",
      ctaTextColor: "#FFFFFF",
    },
  },
};

export function loadCherry() {
  if (document.getElementById("_hw")) return;
  window._hw =
    window._hw ||
    function () {
      (window._hw.q = window._hw.q || []).push(arguments);
    };
  const js = document.createElement("script");
  js.id = "_hw";
  js.src = "https://files.withcherry.com/widgets/widget.js";
  js.async = true;
  const first = document.getElementsByTagName("script")[0];
  first.parentNode.insertBefore(js, first);
}

let floatingInit = false;
export function initCherryFloating() {
  loadCherry();
  if (floatingInit) return;
  floatingInit = true;
  window._hw("init", CHERRY_CONFIG, ["floatingEstimator"]);
}

let sectionInit = false;
export function initCherrySections() {
  loadCherry();
  if (sectionInit) return;
  sectionInit = true;
  window._hw("init", CHERRY_CONFIG, ["hero", "calculator", "howitworks", "faq"]);
}
